/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextReplaceCommentIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Text Replace Comment',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M12.5,2H3.5c-1.24072,0-2.25,1.00977-2.25,2.25v1.11035c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.11035c0-.41309.33643-.75.75-.75h3.75v3.75c0,.41406.33594.75.75.75s.75-.33594.75-.75v-3.75h3.75c.41357,0,.75.33691.75.75v1.11035c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.11035c0-1.24023-1.00928-2.25-2.25-2.25Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M10.75,9.25H2c-.41406,0-.75.33594-.75.75s.33594.75.75.75h5.25v5.75h-1.5498c-.41406,0-.75.33594-.75.75s.33594.75.75.75h3.63965c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75h-.58984v-5.75h2c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M13.93945,19.5c-.09619,0-.19287-.01855-.28516-.05664-.28125-.11523-.46484-.38965-.46484-.69336v-.87988c-1.2168-.05664-2.18945-1.06445-2.18945-2.2959v-2.02539c0-1.26758,1.03076-2.29883,2.29785-2.29883h3.9043c1.26709,0,2.29785,1.03125,2.29785,2.29883v2.02539c0,1.26758-1.03076,2.29883-2.29785,2.29883h-1.34131l-1.38818,1.4043c-.14355.14551-.33691.22266-.5332.22266ZM13.29785,12.75c-.43994,0-.79785.3584-.79785.79883v2.02539c0,.44043.35791.79883.79785.79883h.6416c.35303,0,.64893.24414.729.57227l.3457-.34961c.14062-.14258.33252-.22266.5332-.22266h1.65479c.43994,0,.79785-.3584.79785-.79883v-2.02539c0-.44043-.35791-.79883-.79785-.79883h-3.9043Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
